import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * GA4 SPA Tracker — изпраща page_view event на всеки route change.
 * GA4 Measurement ID = G-7052SPF5H2 (loaded from index.html).
 *
 * Mounts inside <Router>, използва useLocation() за tracking.
 */
export default function GA4Tracker() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (typeof window.gtag !== "function") return;
    window.gtag("event", "page_view", {
      page_path: location.pathname + location.search,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [location]);

  return null;
}

/**
 * Utility: track custom GA4 events.
 * Example: trackEvent("epigenetic_map_calculated", { lifestyle_band: "moderate" });
 */
export function trackEvent(action, params = {}) {
  if (typeof window === "undefined") return;
  if (typeof window.gtag !== "function") return;
  window.gtag("event", action, params);
}
